<template>
	<accordion :header="header" :is-mobile="isMobile" :start-expanded="startExpanded">
		<template #collapsed>
			<div v-show="showInitialsWrapper" class="initialsWrapper">
				<signer-initial v-for="signer in signers" :key="signer.notarizationSignerId" :signer="signer" />
			</div>
		</template>
		<div v-for="signer in signers" :key="signer.notarizationSignerId">
			<signer-initial :signer="signer" />
			<span class="clientName"> {{ signer.firstName }} {{ signer.lastName }} </span>
			<a
				v-if="showViewId"
				href
				data-bs-toggle="modal"
				data-bs-target="#viewIdModal"
				:data-bs-signer-id="signer.notarizationSignerId"
			>View ID</a>
		</div>
	</accordion>
</template>
<script>
import SignerInitial from "./SignerInitial.vue";
import Accordion from "../Accordion.vue";

export default {
	components: { SignerInitial, Accordion },
	props: {
		header: { type: String, required: true },
		isMobile: { type: Boolean, default: false },
		signers: { type: Array, required: true },
		showInitialsWrapper: { type: Boolean, default: true },
		showViewId: { type: Boolean, default: false },
		startExpanded: { type: Boolean, default: true}
	},
};
</script>